import jwtDecode from 'jwt-decode';


interface SessionTokenPayload {
  /**
   * https://<shop-name.myshopify.com/admin>
   */
  iss: string;
  /**
   * https://<shop-name.myshopify.com>
   */
  dest: string;
  /**
   * <api key>
   */
  aud: string;
  /**
   * <user ID>
   */
  sub: string;
  /**
   * <time in seconds>
   */
  exp: number;
  /**
   * <time in seconds>
   */
  nbf: number;
  /**
   * <time in seconds>
   */
  iat: number;
  /**
   * <random UUID>
   */
  jti: string;
  /**
   * <session ID>
   */
  sid: string;
}

export function getIsEmbedded() {
  return process.env.REACT_APP_RUN_AS_STANDALONE !== 'true';
}

export const getAppConfig = () => {
  const params = new URLSearchParams(document.location.search);
  /**
   * should be base64 encoded host name, where host matches the following pattern: <shop name>.myshopify.com/admin
   * I.g. test-iterable-store.myshopify.com/admin
   */
  const host: string | null = params.get('host');
  const isEmbedded: boolean = getIsEmbedded();

  if (!isEmbedded) {
    return null;
  }

  if (!host) {
    throw Error('App Bridge config error: host is not defined');
  }

  if (!process.env.REACT_APP_SHOPIFY_API_KEY) {
    throw Error('App Bridge config error: apiKey is not defined');
  }

  return {
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    host,
    // forceRedirect: true,
  };
};

export async function delay (delay: number = 1000, callback = () => {}) {
  const delayPromise = (ms: number) => new Promise(res => setTimeout(res, ms));
  await delayPromise(delay);
  callback();
};

// TODO: the same can be accomplished on server-side
export const getShop = (token: string): string => {
  let shop: string = '';

  try {
    if (token) {
      const decoded: SessionTokenPayload = jwtDecode(token);
      // https://shopify.dev/apps/auth/session-tokens/how-session-tokens-work#payload;
      shop = decoded.dest;
    }
  } catch (err) {
    throw Error('Cannot identify shop');
  }

  return shop.replace(/^https:\/\//, '');
};
